///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('.js-pr-review-comment-button')) {
      document.querySelector('.process-review-form').addEventListener('click', (e) => {
        const target = e.target;

        if (target.classList.contains('fa-comment') ||
            target.classList.contains('js-pr-review-comment-button')) {
          const reviewComment = new ReviewComment(target);

          reviewComment.addCancelListener();
          reviewComment.addSaveAndCollapseListener();
          reviewComment.showReviewComment();

          toggleCommentButtonStyle(reviewComment);

          target.addEventListener('click', function() {
            reviewComment.showReviewComment();
          });
        }
      });
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Constructors
  //
  ///////////////////////////////////////////////////////////////////

  function ReviewComment(target) {
    if (target.classList.contains('js-pr-review-comment-button')) {
      this.commentButton = target;
    } else if (target.classList.contains('fa-comment')) {
      this.commentButton = target.closest('.js-pr-review-comment-button');
    }

    this.commentCard   = this.commentButton
                             .parentElement
                             .parentElement
                             .nextElementSibling
                             .nextElementSibling
                             .querySelector('.js-pr-review-comment-card');

    this.commentField  = this.commentCard.querySelector('.js-pr-review-comment-field');
    this.cancelButton  = this.commentCard.querySelector('.js-pr-review-cancel-button');
    this.saveButton    = this.commentCard.querySelector('.js-pr-review-save-button');
  }



  ///////////////////////////////////////////////////////////////////
  //
  // Prototype Definitions
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Displays hidden review comment field
  //
  ReviewComment.prototype.showReviewComment = function() {
    // display associated review comment card
    this.commentCard.classList.remove('d-none');

    // hide review comment button
    this.commentButton.classList.add('d-none');
  };

  ///////////////////////////////////////////////
  //
  // Description - Adds click event listener to
  //               cancel button that clears input
  //               field, hides review comment card
  //               and displays the review comment
  //               icon button.
  //
  ReviewComment.prototype.addCancelListener = function() {
    // store 'this' for correct reference to review
    // comment object inside of event listener block
    const reviewCommentObj = this;

    // add event listener to comment card's cancel button
    reviewCommentObj.cancelButton.addEventListener('click', function() {
      // clear input
      reviewCommentObj.commentField.value = '';

      // hide review comment card
      reviewCommentObj.commentCard.classList.add('d-none');

      // display review comment button
      reviewCommentObj.commentButton.classList.remove('d-none');
    });
  };

  ///////////////////////////////////////////////
  //
  // Description - Submit form for comment save and
  //               hide comment box. Change speech
  //               balloon icon to solid color to
  //               indicate a review comment is present.
  //
  ReviewComment.prototype.addSaveAndCollapseListener = function() {
    // store 'this' for correct reference to review
    // comment object inside of event listener block
    const reviewCommentObj = this;

    // add event listener to comment card's save button
    reviewCommentObj.saveButton.addEventListener('click', function() {
      // hide review comment card
      reviewCommentObj.commentCard.classList.add('d-none');

      // display review comment button and change to solid color
      reviewCommentObj.commentButton.classList.remove('d-none');
      toggleCommentButtonStyle(reviewCommentObj);

      // hide cancel button on comment save
      if (!reviewCommentObj.cancelButton.classList.contains('d-none')) {
        reviewCommentObj.cancelButton.classList.add('d-none');
      }
    });
  };


  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  function toggleCommentButtonStyle(reviewCommentObj) {
    if (!reviewCommentObj.commentField.value == '') {
      reviewCommentObj.commentButton.classList.remove('btn-outline-info');
      reviewCommentObj.commentButton.classList.add('btn-info');
      reviewCommentObj.commentButton.title = 'Edit Anchor Review comment';
    } else {
      reviewCommentObj.commentButton.classList.remove('btn-info');
      reviewCommentObj.commentButton.classList.add('btn-outline-info');
      reviewCommentObj.commentButton.title = 'Add Anchor Review comment';
    }
  }
}());
